module.exports = __webpack_public_path__ + "static/media/tripsavvi_no_city.453f5983.png";